export default __webpack_public_path__ + "media/fonts/GTWalsheim/gt-walsheim-regular-oblique-web-aea28b23a11f5f1e643159c3d4a9aa66.eot";